import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  getPromoCodeList,
  updatePromoCode,
} from "../../store/slice/promoCodeSlice";
import { useNavigate } from "react-router-dom";

const DeletePromoCode = ({
  deleteModal,
  setDeleteModal,
  deleteId,
  setDeleteId,
  handleClose,
  pageNumber,
  totalCount,
}) => {
  const { t } = useTranslation("common");
  const showHideClassName = deleteModal && "user_detail_modal_show";
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const deletePromoCodeHandler = () => {
    const data = {
      delete_status: "1",
    };
    dispatch(
      updatePromoCode({
        data,
        id: deleteId,
        cb: (err, res) => {
          if (err) {
            console.log("err", err);
          } else {
            setDeleteModal(false);
            setDeleteId("");
            toast.error(t("toast.delete_promo"), {
              autoClose: 3000,
            });
            if (
              totalCount &&
              totalCount[totalCount?.length - 1] == 1 &&
              +pageNumber !== 1
            ) {
              navigate(`/promo-code/page/${pageNumber - 1}`);
            } else {
              dispatch(
                getPromoCodeList({ start: (pageNumber - 1) * 10, limit: 10 })
              );
            }
          }
        },
      })
    );
  };

  return (
    <>
      <div
        className={`user_detail_modal_bg  ${showHideClassName}`}
        onClick={handleClose}
      ></div>
      <section
        className={`user_detail_modal_main delete_feedback_modal ${showHideClassName}`}
      >
        <div className="inquiry_complaint_detail_section">
          <h2 className="announcement_page-view-modal">
            {t("modal.delete.delete_res_image")}
          </h2>
          <h4 className="announcement_page-view-modal delete_feedback_subheading">
            {t("toast.promo_delete_msg")}
          </h4>
          <div className="delete_feedback_btn-container">
            <button
              type="button"
              onClick={handleClose}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn secondary_btn"
            >
              {t("common.close")}
            </button>
            <button
              type="button"
              onClick={deletePromoCodeHandler}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn ml-20"
            >
              {t("common.delete")}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeletePromoCode;
